export const GET_MENU_REQUEST = 'GET_MENU_REQUEST';
export const GET_MENU_SUCCESS = 'GET_MENU_SUCCESS';
export const GET_MENU_ERROR = 'GET_MENU_ERROR';
export const GET_MENU_FROM_IIKO_REQUEST = 'GET_MENU_FROM_IIKO_REQUEST';
export const GET_MENU_FROM_IIKO_SUCCESS = 'GET_MENU_FROM_IIKO_SUCCESS';
export const GET_MENU_FROM_IIKO_ERROR = 'GET_MENU_FROM_IIKO_ERROR';
export const CHANGE_VISIBLE_MENU_LIST_ITEM = 'CHANGE_VISIBLE_MENU_LIST_ITEM';
export const OPEN_ALL_MENU = 'OPEN_ALL_MENU';
export const CLOSE_ALL_MENU = 'CLOSE_ALL_MENU';
